import * as React from 'react';
import {
  useForm, FormProvider,
} from 'react-hook-form';
import { Box, BoxProps } from '@mui/material';
import { cloneDeep, isEqual } from 'lodash';
import FToolbar from './toolbar';
import SaveButton from './SaveButton';
import SaveButtonValid from './SaveButtonValid';

function Toolbar() {
  return (
    <FToolbar>
      <SaveButton />
    </FToolbar>
  );
}
export function ToolbarValid() {
  return (
    <FToolbar>
      <SaveButtonValid />
    </FToolbar>
  );
}

type IFormProps = React.DetailedHTMLProps<
  React.FormHTMLAttributes<HTMLFormElement>, HTMLFormElement
> & {
  setResult?:any,
  defaultValues?: {[k: string]: any };
  values?: {[k: string]: any };
  toolbar?: React.ReactNode;
} & BoxProps;

export default function Form(props: IFormProps) {
  const {
    defaultValues = {}, setResult,
    toolbar = <Toolbar />,
    children, onSubmit, values,
    ...rest
  } = props;
  const methods = useForm({
    defaultValues,
    mode: 'onChange'
  });

  const handleSubmit = async (e) => {
    await onSubmit(e);
    methods.reset(e);
  };

  React.useEffect(() => {
    if (values)
      methods.reset(values);
  }, [values]);

  React.useEffect(() => {
    if (!setResult) {
      return;
    }

    const lastResultRef = { current: undefined };
    const emitResult = () => {
      const nextValue = cloneDeep(methods.getValues());
      if (isEqual(lastResultRef.current, nextValue)) {
        return;
      }

      lastResultRef.current = nextValue;
      setResult(nextValue);
    };

    emitResult();
    const subscription = (methods.watch as any)(() => {
      emitResult();
    });

    return () => {
      if (typeof subscription === 'function') {
        subscription();
      } else {
        subscription?.unsubscribe?.();
      }
    };
  }, [setResult]);

  return (
    <FormProvider {...methods} >
      <form onSubmit={methods.handleSubmit(handleSubmit)}
        {...rest}
      >
        <Box pb={2} px={4}  {...rest} >
          {children}
        </Box>
        {toolbar}
      </form>
    </FormProvider>
  );
}
